import { makeStyles } from "@material-ui/styles";

export default makeStyles(({ palette, spacing }) => ({
  contentText: {
    color: palette.text.default,
    fontSize: "0.9rem"
  },
  dialogActions: {
    marginTop: spacing(2),
    width: "65%",
    justifyContent: "space-around"
  },
  dialogPaper: {
    padding: spacing(4),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center"
  },
  modalText: {
    lineHeight: 1.5
  }
}));
